import React from 'react';
import { Clock, TrendingUp, BrainCircuit } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-16 md:py-24 px-4 bg-cream" data-id="element-553">
      <div className="max-w-4xl mx-auto" data-id="element-554">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-12 text-center" data-id="element-555">
          ⏰ Por Qué Decidir Ahora
        </h2>

        <div className="space-y-8" data-id="element-556">
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border-l-4 border-urgency flex flex-col md:flex-row gap-6 items-start" data-id="element-557">
            <div className="bg-urgency/10 p-4 rounded-full shrink-0" data-id="element-558">
              <TrendingUp className="text-urgency" size={32} data-id="element-559" />
            </div>
            <div data-id="element-560">
              <h3 className="text-xl font-bold text-dark mb-3" data-id="element-561">
                Razón #1: El Precio Sube
              </h3>
              <p className="text-dark/80 leading-relaxed" data-id="element-562">
                Este es el precio de lanzamiento. Una vez que se superen las
                primeras unidades vendidas, el precio vuelve a 37,90 €. No es un
                truco de marketing. Es la política de lanzamiento real.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border-l-4 border-forest flex flex-col md:flex-row gap-6 items-start" data-id="element-563">
            <div className="bg-forest/10 p-4 rounded-full shrink-0" data-id="element-564">
              <Clock className="text-forest" size={32} data-id="element-565" />
            </div>
            <div data-id="element-566">
              <h3 className="text-xl font-bold text-dark mb-3" data-id="element-567">
                Razón #2: Cada Noche Que Pasa Es Una Noche Perdida
              </h3>
              <p className="text-dark/80 leading-relaxed" data-id="element-568">
                La inflamación crónica no toma días libres. Cada noche que cenas
                de la misma manera, acumulas un ciclo inflamatorio más. El mejor
                momento para empezar fue hace un año. El segundo mejor momento
                es esta noche.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border-l-4 border-gold flex flex-col md:flex-row gap-6 items-start" data-id="element-569">
            <div className="bg-gold/20 p-4 rounded-full shrink-0" data-id="element-570">
              <BrainCircuit className="text-gold-dark" size={32} data-id="element-571" />
            </div>
            <div data-id="element-572">
              <h3 className="text-xl font-bold text-dark mb-3" data-id="element-573">
                Razón #3: Tu Cuerpo Tiene Memoria
              </h3>
              <p className="text-dark/80 leading-relaxed" data-id="element-574">
                Cuanto más tiempo permanece el sistema inflamatorio activado,
                más tiempo tarda en regularse. Empezar hoy significa resultados
                esta semana. Esperar un mes significa empezar desde más atrás.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}